import MarketMap from "~/pages/market-map";

import { createRouter, createWebHistory } from "vue-router";

const routes = [
  { path: "/", component: MarketMap },
  { path: "/ru", component: () => import("../pages/ru") }
];

export const router = createRouter({ history: createWebHistory(process.env.BASE_URL), routes });
